/**
 * shopping-video.js
 * 购物视频轮播组件 - Web Component
 * Swiper 11 + loop + centeredSlides
 * 
 * 已知问题：Swiper 11 的 loop + slideToClickedSlide 在快速跳转时有 bug（slide DOM 不更新）
 * 解决方案：不使用 slideToClickedSlide，手动处理点击，每次只移动 1 步
 */

class ShoppingVideoCarousel extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
  }

  connectedCallback() {
    if (typeof Swiper !== 'undefined') {
      this.init();
    } else {
      document.addEventListener('DOMContentLoaded', () => {
        if (typeof Swiper !== 'undefined') {
          this.init();
        }
      });
    }
  }

  init() {
    const pcSlidesPerView = parseFloat(this.dataset.slidesPerView) || 4;
    const mobileSlidesPerView = parseFloat(this.dataset.mobileSlidesPerView) || 1.4;
    const swiperEl = this.querySelector('.shopping-video__swiper');
    if (!swiperEl) return;

    this.swiper = new Swiper(swiperEl, {
      slidesPerView: mobileSlidesPerView,
      spaceBetween: 0,
      loop: true,
      centeredSlides: true,
      speed: 400,
      pagination: {
        el: swiperEl.querySelector('.swiper-pagination'),
        clickable: true
      },
      breakpoints: {
        768: {
          slidesPerView: pcSlidesPerView
        }
      },
      on: {
        slideChangeTransitionEnd: () => {
          this.pauseAllVideos();
        }
      }
    });

    this.bindPlayButtons();
    this.bindSlideClick();
  }

  bindSlideClick() {
    const swiperEl = this.querySelector('.shopping-video__swiper');
    if (!swiperEl || !this.swiper) return;

    swiperEl.addEventListener('click', (e) => {
      // 如果点击的是播放按钮，不处理
      if (e.target.closest('.shopping-video__play-btn')) return;

      const clickedSlide = e.target.closest('.swiper-slide');
      if (!clickedSlide) return;
      if (clickedSlide.classList.contains('swiper-slide-active')) return;

      // 判断点击的是左侧还是右侧
      const activeSlide = swiperEl.querySelector('.swiper-slide-active');
      if (!activeSlide) return;

      const slides = Array.from(swiperEl.querySelectorAll('.swiper-slide'));
      const activeIndex = slides.indexOf(activeSlide);
      const clickedIndex = slides.indexOf(clickedSlide);

      if (clickedIndex < activeIndex) {
        this.swiper.slidePrev();
      } else {
        this.swiper.slideNext();
      }
    });
  }

  bindPlayButtons() {
    const swiperEl = this.querySelector('.shopping-video__swiper');
    if (!swiperEl) return;

    swiperEl.addEventListener('click', (e) => {
      const btn = e.target.closest('.shopping-video__play-btn');
      if (!btn) return;
      e.stopPropagation();

      const slide = btn.closest('.swiper-slide');
      if (!slide || !slide.classList.contains('swiper-slide-active')) return;

      const videoWrap = btn.closest('.shopping-video__video-wrap');
      if (!videoWrap) return;
      this.playVideo(videoWrap);
    });
  }

  playVideo(videoWrap) {
    const poster = videoWrap.querySelector('.shopping-video__poster');
    const video = videoWrap.querySelector('.shopping-video__video');
    if (!poster || !video) return;

    this.pauseAllVideos();

    poster.style.display = 'none';
    video.style.display = 'block';
    video.play();
  }

  pauseAllVideos() {
    const videoWraps = this.querySelectorAll('.shopping-video__video-wrap');
    videoWraps.forEach((wrap) => {
      const poster = wrap.querySelector('.shopping-video__poster');
      const video = wrap.querySelector('.shopping-video__video');
      if (video) {
        video.pause();
        video.style.display = 'none';
      }
      if (poster) {
        poster.style.display = '';
      }
    });
  }
}

if (!customElements.get('shopping-video-carousel')) {
  customElements.define('shopping-video-carousel', ShoppingVideoCarousel);
}
